import {
  SET_ACTIONS_POPUP_STATUS,
  SET_CHATBOT_ANSWER,
  SET_HISTORY,
  SET_LOADING,
  SET_SEARCH_TEXT,
  SET_STATUS,
} from '../reducers/aiChatbot';
import { AI_LOADING_OPTIONS, PROMPT_TYPE } from '../../constants/aiChatbot';
import api from '../../utils/api';
import { alertError } from '../actions/alert';

export const adjustAiLoadingOption = (option, value) => ({ type: SET_LOADING, payload: { key: option, value } });
export const adjustUserChatHistory = (history) => ({ type: SET_HISTORY, payload: { history } });
export const adjustChatbotAnswer = (content) => ({
  type: SET_CHATBOT_ANSWER,
  payload: {
    chatbotAnswer: {
      content: content,
      promptType: PROMPT_TYPE.AI,
      createdAt: new Date().toISOString(),
    },
  },
});
export const adjustActionsPopupStatus = (actionsPopupStatus) => ({
  type: SET_ACTIONS_POPUP_STATUS,
  payload: { actionsPopupStatus },
});
export const adjustAiChatbotStatus = (status) => ({ type: SET_STATUS, payload: { status } });
export const adjustSearchText = (text) => ({ type: SET_SEARCH_TEXT, payload: { text } });

export const getChatHistory = () => async (dispatch, getState) => {
  dispatch(adjustAiLoadingOption(AI_LOADING_OPTIONS.HISTORY, true));

  const state = getState();
  const { supplierId } = state.role;

  try {
    const response = await api.get(`/suppliers/${supplierId}/chat`);

    dispatch(adjustUserChatHistory(response.data.chatHistory));
  } catch (e) {
    dispatch(alertError(e));
  } finally {
    dispatch(adjustAiLoadingOption(AI_LOADING_OPTIONS.HISTORY, false));
  }
};

export const sendUserPrompt = (userPrompt: string) => async (dispatch, getState) => {
  dispatch(adjustAiLoadingOption(AI_LOADING_OPTIONS.CHATBOT_ANSWER, true));
  const state = getState();
  const { supplierId } = state.role;

  try {
    const response = await api.post(`/suppliers/${supplierId}/chat`, { userPrompt });

    dispatch(adjustChatbotAnswer(response.data.chatbotPrompt));
  } catch (e) {
    dispatch(alertError(e));
  } finally {
    dispatch(adjustAiLoadingOption(AI_LOADING_OPTIONS.CHATBOT_ANSWER, false));
  }
};

export const resetUserHistory = () => async (dispatch, getState) => {
  dispatch(adjustAiLoadingOption(AI_LOADING_OPTIONS.HISTORY, true));
  const state = getState();
  const { supplierId } = state.role;

  try {
    await api.delete(`/suppliers/${supplierId}/chat`);

    dispatch(adjustUserChatHistory({}));
  } catch (e) {
    dispatch(alertError(e));
  } finally {
    dispatch(adjustAiLoadingOption(AI_LOADING_OPTIONS.HISTORY, false));
  }
};
